/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderUnderlineMinus: {
  name: 'folder-underline-minus';
  data: string;
} = {
  name: 'folder-underline-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 1a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h7v2H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-6v-2h7a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-7.586L10 1.586A2 2 0 0 0 8.586 1H4Zm16 15H4V3h4.586L11 5.414A2 2 0 0 0 12.414 6H20v10Zm-10-6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z" fill="currentColor"/></svg>`,
};
